import React, { useEffect, useState } from 'react';
import { Collapse, Input, Skeleton } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { APP_PREFIX_PATH } from "../../../configs/AppConfig";
import { useDispatch, useSelector } from "react-redux";
// import { DIR_RTL } from "../../../constants/ThemeConstant";
import { getCountries } from "../../../redux/actions";
import { getAttachment } from 'utils/attachment';
// import BranchMap from '../branches/BranchMap';

const { Panel } = Collapse;

function OrderDelivery({ mode }) {
    const history = useHistory()
    const { locale } = useSelector(state => state.theme);
    const { countries } = useSelector(state => state.fetchedData);
    // const [getLocation, setGetLocation] = useState({lat: 0, lng: 0});
    const dispatch = useDispatch();
    const [activeKey, setActiveKey] = useState('');
    const [countrie, setCountrie] = useState([]);
    
    useEffect(() => {
        dispatch(getCountries(''));
        // if (navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition(showPosition);
        // } else {
        //     notification.error({message: 'Geolocation is not supported by this browser.'});
        // }
    }, []);

    // const showPosition = (position) => {
    //     setGetLocation({lat: position.coords.latitude, lng: position.coords.longitude})
    // }

    // useEffect(() => {
    //     localStorage.setItem('location', JSON.stringify(getLocation));
    // }, [getLocation])

    useEffect(() => {
        setCountrie(countries)
        countries?.length && setActiveKey(prev => ({...prev, countryKey: countries[0]?.id}))
    }, [countries])

    const setArea = (area) => {
        localStorage.setItem("selected-mode", 'delivery')           
        localStorage.setItem('selected-area', JSON.stringify(area)) 
        if (localStorage.getItem('fulfillment-time') === null) {                
            history.push(APP_PREFIX_PATH + '/estimated-time')
        } else {
            history.push(APP_PREFIX_PATH + '/menu')
        }
    }
    console.log(activeKey)
    const handleSearch = (search) => {
        if (search) {
            countries.map(c => {
                c.cities.map(s => {
                    if (s.nameEng.toLowerCase().indexOf(search.toLowerCase()) > - 1) {
                        setActiveKey(prev => ({...prev, countryKey: c.id}))
                        setCountrie([c]);
                    } else {
                        s.areas.map(e => {
                            if (e.nameEng.toLowerCase().indexOf(search.toLowerCase()) > - 1) {
                                setActiveKey(prev => ({...prev, cityKey: s.id}))
                                setCountrie([c]);
                            } else {
                                setCountrie([]);
                            }
                        })
                    }
                })
            })
        } else {
            setCountrie(countries);
            setActiveKey({countryKey: '', cityKey: ''})
        }
    }

    if (mode !== 'delivery') return null;

    return (
        <>
            <div style={{ fontSize: '18px' }}
                className='order-mode__prev cursor-default pb-3 pt-2 mb-0 border-bottom'>Select Area
            </div>
            <div className="mt-3 mb-2">
                <Input
                    // value={value}
                    onChange={(e) => handleSearch(e.target.value)}
                    className='text-left d-flex align-items-center mb-3 order-input'
                    prefix={<SearchOutlined style={{ fontSize: 18 }} />}
                    placeholder={'Search Cities and Areas'}
                    allowClear={true}
                />
            </div>
            {countries.length === 0 ?
                <>
                    <Skeleton active paragraph={{rows: 2, width: ['100', '100']}}/>
                    <Skeleton active paragraph={{rows: 2, width: ['100', '100']}}/>
                </> :
                <Collapse ghost accordion expandIconPosition='right' className='collapseDelivery' onChange={(key) => setActiveKey(prev => ({...prev, countryKey: key}))} activeKey={activeKey?.countryKey}>
                    {countrie.map(country => <Panel header={<div className="font-16 font-bold text-black">
                        {country.attachment.id ? <img src={getAttachment(country.attachment.id)} className='countryFlag' alt="#"/> : ""}
                        {(locale === 'en' ? country?.nameEng : country?.nameAr)}
                    </div>} key={country?.id}>
                        <Collapse ghost accordion expandIconPosition='right' onChange={(key) => setActiveKey(prev => ({...prev, cityKey: key}))} activeKey={activeKey?.cityKey}>
                            {country?.cities?.map(city => <Panel header={<div className="font-16 text-black">
                                {(locale === 'en' ? city?.nameEng : city?.nameAr)}
                             </div>} key={city?.id}>
                                {city.areas.map(area =>
                                    <div
                                        key={area.id}
                                        onClick={() => setArea(area)}
                                        className='border-bottom py-3 cursor-pointer font-weight-normal'
                                    >
                                        {locale === 'en' ? area?.nameEng : area?.nameAr}
                                    </div>
                                )}
                            </Panel>)}
                        </Collapse>
                    </Panel>)}
                </Collapse>
            }
            {/* <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}
                className='order-mode__prev cursor-default pb-3 pt-2 mb-0 border-bottom'>Choose your location 
            </div>
            <div className='border'>
                <BranchMap lat={getLocation.lat} lng={getLocation.lng} setGetLocation={setGetLocation}/>
            </div> */}
        </>
    );
}

export default OrderDelivery;